import React, { useEffect, useState } from "react";
import { Badge, Card, Dropdown, Table } from "react-bootstrap";
import {
  getWithdrawalRequests,
  withdrawalRequestAction,
} from "../../services/UserServices/UserService";
import Spinner from "../components/Common/Spinner";

import Pagination from "../components/Common/Pagination";
import PageTitle from "../layouts/PageTitle";
import ReferralCode from "../components/Modal/ReferralCode";
import { useNavigate } from "react-router-dom";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";

export default function WithdrawalList() {
  const [loader, setLoader] = useState(false);

  const [datas, setDatas] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [initialFetch, setInitialFetch] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const limit = 10;
  const navigate = useNavigate();

  async function getTableData() {
    setLoader(true);
    try {
      const response = await getWithdrawalRequests(currentPage, limit);
      console.log(response.data, "12365");
      setDatas(response.data.data?.requests);
      setLoader(false);
      const total = response.data.data?.count;
      setPageCount(Math.ceil(total / limit));
      setListLength(response.data.data?.count);
      setInitialFetch(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  }

  const onComplete = async (id) => {
    setLoader(true);
    try {
      const postData = { requestId: id };
      const response = await withdrawalRequestAction(postData);
      notifyTopRight(response.data?.message);
      getTableData();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  useEffect(() => {
    getTableData();
  }, [currentPage]);

  return (
    <div>
      <PageTitle
        activeMenu="Withdrawal Requests"
        motherMenu="Withdrawal Requests"
      />
      <Card>
        <Card.Body className="pb-0 pt-3">
          {loader ? (
            <Spinner />
          ) : (
            <Table responsive className="mostly-customized-scrollbar mb-0">
              <thead style={{ color: "black" }}>
                <tr>
                  <th>
                    <strong>name</strong>
                  </th>
                  <th>
                    <strong>PayNow Number</strong>
                  </th>
                  <th>
                    <strong>Available Balance</strong>
                  </th>
                  <th>
                    <strong>amount requested</strong>
                  </th>
                  <th>
                    <strong>status</strong>
                  </th>
                  <th>
                    <strong>ACTION</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {datas &&
                  datas?.map((item, i) => (
                    <tr key={i}>
                      <td>{item?.user ? item?.user?.name : "-"}</td>
                      <td>{item?.payNumber}</td>
                      <td className="pointer link-text" onClick={() => navigate("/redeemed-by", { state: { id: item.user?._id, table:"table2"} })}>
                        ${item?.availableBalance}
                      </td>
                      <td>${item?.amount}</td>
                      <td>
                        <Badge bg="" className="badge-warning">
                          {item?.status}
                        </Badge>
                      </td>

                      <td>
                        <button
                          onClick={() => onComplete(item._id)}
                          className="btn btn-success py-2 px-2"
                        >
                          Complete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
          {datas?.length === 0 && !loader ? (
            <div className="justify-content-center d-flex my-5 ">
              Sorry, Data Not Found!
            </div>
          ) : (
            ""
          )}
        </Card.Body>
        {datas?.length !== 0 && (
          <div className="card-footer clearfix">
            <div className="d-block d-sm-flex justify-content-between align-items-center">
              <div className="dataTables_info">
                Showing {currentPage * limit + 1} to{" "}
                {listLength > (currentPage + 1) * limit
                  ? (currentPage + 1) * limit
                  : listLength}{" "}
                of {listLength} entries
              </div>
              <Pagination
                pageCount={pageCount}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            </div>
          </div>
        )}
      </Card>

      {showModal && (
        <ReferralCode
          show={showModal}
          table={getTableData}
          onHide={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
